import axios from 'axios';
import { useEffect, useState } from 'react'
import { CircularProgress, Pagination } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import {ProjectConfig} from 'Global';
import TopBar from 'elements/TopBar/TopBar';
import FiltersApplied from 'elements/Filters/FiltersApplied';


export default function NotificacioneslList (props:any) {

  /*================================================
  FILTERS
  =================================================*/
  const filters = [
    {type: "text", label: "Nombre", name: "name", value: ""},
    {type: "date", label: "Fecha", name: "fecha", value: ""},
  ]
  const [filtersValues, setFiltersValues] = useState<any>({});

  const setFilters = (tempFilters: any) => {
    setFiltersValues(tempFilters);
  }
  /*================================================= 
  ==================================================*/

  const [list, setList] = useState<any []>([]);
  const [total_pages, setTotalPages] = useState(0);
  const currentPage=parseInt(localStorage.getItem('page') || "1");
  const [page, setPage] = useState(currentPage);


  /*=========================================================
  LOAD LIST            
  =========================================================*/

  useEffect(() => {
    console.log("entro");
    props.setLoading(true);
      axios.get(ProjectConfig.api_url,
      {
        params: {
          request: 'notificaciones_list',
          filters: filtersValues,
          page: page,
        }
      })
        .then((response) => {
          setList(response.data.list)
          setTotalPages(response.data.total_pages)
          props.setLoading(false);
          console.log("response!!")
        })
        .catch((err) => {
          console.log(err.data);
        })
        localStorage.setItem('page', page.toString())
    
  }, [page, filtersValues])
  /*=========================================================*/


  return (
    <div id='notificaciones' className='module_container'>
      
      <div className="module_topBar">
        <TopBar title='notificaciones' filters={filters} setFilters={setFilters}/>
      </div>
      

      <FiltersApplied filtersValues={filtersValues} setFiltersValues={setFiltersValues}/>
     

      
      <div className='module_content'>
        <div id="task_list_container" className="flex_column">
          {list.map((list_item,key) => (

              <Link className='CardNotificacion' key={key} to={'/notificaciones/'+list_item.notificacion_id}
              onClick={()=> props.setLoading(true)}>    
                <div className='CardNotificacionLeft'>
                  <span className='CardListTitle'>{list_item.title}</span>
                  <span className='CardListSubTitle'>{list_item.date}</span>
                </div>
              </Link>
          ))}
          <Pagination count={total_pages} page={page}  onChange={(event, value) => {
            setPage(value)
          }
          } 
          color="primary"
          style={{"marginTop": "20px","alignSelf": "center"}}
          />
 
        </div>
      </div>
    </div>
  );
};



